import React, { useState, useEffect, useRef } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import BarraNavegacion from './BarraNavegacion';
import Finalizar from './FinalizarCompra.jsx';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faUserNurse } from '@fortawesome/free-solid-svg-icons';
import FinalizarCompra from './FinalizarCompra.jsx'
import FruitLoader from './FruitLoader.jsx';
import jsPDF from 'jspdf';
import ProductosAgotados from './ProductosAgotados.jsx';
import Cambios from './Cambios.jsx';

const INCREMENTAR_VENDIDOS = gql`
  mutation incrementarVendidos($id: ID!, $cantidad: Int!) {
    incrementarVendidos(id: $id, cantidad: $cantidad) {
      _id
      cantidad
    }
  }
`;

const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

const OBTENER_PESO = gql`
  query {
    pesoBascula
  }
`;

 /*const ACTUALIZAR_STOCK = gql`
  mutation actualizarStock($id: ID!, $nuevoStock: Int) {
    actualizarStock(_id: $id, stock: $nuevoStock) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;*/

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $fecha: Date
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      fecha: $fecha
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

const ULTIMO_PEDIDO= gql `
query {
  obtenerUltimoPedido {
    _id
    numeroPedido
    nombreCliente
    fecha
    estado
    productos
  }
}

`;

function formatFechaGMT5() {
  const fecha = new Date();
  const offset = 0*60; // GMT-5
  const localTime = new Date(fecha.getTime() + offset * 60 * 1000);
  const year = localTime.getFullYear();
  const month = (localTime.getMonth() + 1).toString().padStart(2, '0');
  const day = localTime.getDate().toString().padStart(2, '0');
  const hours = localTime.getHours().toString().padStart(2, '0');
  const minutes = localTime.getMinutes().toString().padStart(2, '0');
  

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

function GetProductos(props) {
  const [carrito, setCarrito] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [total, setTotal] = useState(0);
  const inputRef = useRef(null);
 const [dineroCliente, setDineroCliente] = useState('');
const [cambio, setCambio] = useState(0);
const [mantenerFocoBusqueda, setMantenerFocoBusqueda] = useState(true);


  // const [actualizarStockProducto] = useMutation(ACTUALIZAR_STOCK);
  const productoSeleccionadoRef = useRef(null);
  const [estado, setEstado] = useState("esperando");
   const [fecha, setFecha] = useState(getFechaGMT5());
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [whatsappCliente, setWhatsappCliente] = useState("");
  const [notaPedido, setNotaPedido] = useState("");
  const [productos, setProductos] = useState("");
  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [carritoLocal, setCarritoLocal] = useState([]);
  const [incrementarVendidos] = useMutation(INCREMENTAR_VENDIDOS);
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
const { data: productosData, loading: productosLoading, error: productosError } = useQuery(GET_PRODUCTOS);
const { data: ultimopedidoData, loading: ultimopedidoLoading, error: ultimopedidoError, refetch: refetchUltimoPedido } = useQuery(ULTIMO_PEDIDO);

  const { data: pesoData, loading: pesoLoading, error: pesoError } = useQuery(OBTENER_PESO, {
    pollInterval: 1000,
  });

   const [modalActivo, setModalActivo] = useState(null);

   const [loadingPedido, setLoadingPedido] = useState(false);


function getFechaGMT5() {
  const fechaUTC = new Date();

  // Diferencia de Colombia respecto a UTC: -5 horas
  const offsetColombia = -5 * 60;

  // Ajustar la fecha
  const fechaColombia = new Date(fechaUTC.getTime() + offsetColombia * 60 * 1000);

  // Retornar string ISO (sin la Z final para que no lo interprete como UTC)
  const isoString = fechaColombia.toISOString().slice(0, 19).replace('T', ' ');
  
  return isoString; 
}
  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(carrito));
    recalcularTotal(); // Recalcular el total cuando el carrito cambia
  }, [carrito]);



  useEffect(() => {
  const interval = setInterval(() => {
    const activeElement = document.activeElement;
    const esInputBusqueda = inputRef.current === activeElement;
    const esOtroInput = activeElement.tagName === 'INPUT' && !esInputBusqueda;

    if (!esOtroInput && inputRef.current) {
      inputRef.current.focus();
    }
  }, 300); // menos frecuente que antes

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  if (mantenerFocoBusqueda && inputRef.current) {
    inputRef.current.focus();
  }
}, [mantenerFocoBusqueda]);




 const buscarYAgregarProducto = (entrada) => {
  if (!productosData || !productosData.getProductos) {
    console.error("Datos de productos no disponibles");
    alert("Datos de productos no cargados. Por favor, intente nuevamente.");
    return;
  }

  const productos = productosData.getProductos;
  const entradaNormalizada = entrada?.toString().trim().toLowerCase();

  // Buscar por código (convertido a string y sin espacios)
  let productoFiltrado = productos.find(
    (producto) =>
      producto?.codigo?.toString().trim().toLowerCase() === entradaNormalizada
  );

  // Si no encontró por código, buscar por nombre
  if (!productoFiltrado && entradaNormalizada !== "") {
    productoFiltrado = productos.find(
      (producto) =>
        typeof producto?.nombre === "string" &&
        producto.nombre.toLowerCase().includes(entradaNormalizada)
    );
  }

  if (productoFiltrado) {
    agregarAlCarrito(productoFiltrado);
} else {
    alert("Producto no encontrado");
  }
};


const agregarAlCarrito = async (producto) => {


  let cantidad = 1;

  // Si es producto por peso (codigo === '1'), usa el peso de la báscula
  if (producto.codigo === "1") {
    const peso = parseFloat(pesoData?.pesoBascula || 0);

    if (!peso || isNaN(peso) || peso <= 0) {
      alert('No se detectó un peso válido en la báscula');
      return;
    }

    cantidad = Math.round(peso * 1000); // convertir kg a gramos como entero
  }

  const productoEnCarrito = carrito.find((item) => item._id === producto._id);

  if (productoEnCarrito) {
    const nuevaCantidad = productoEnCarrito.cantidad + cantidad;

    if (nuevaCantidad <= producto.stock) {
      const carritoActualizado = carrito.map((item) =>
        item._id === producto._id
          ? { ...item, cantidad: nuevaCantidad }
          : item
      );
      setCarrito(carritoActualizado);
    } else {
      // alert('No hay suficiente stock disponible para este producto.');
    }
  } else {
    if (producto.stock >= cantidad) {
      setCarrito([...carrito, { ...producto, cantidad }]);
    } else {
      // alert('No hay suficiente stock disponible para este producto.');
    }
  }
  setFiltro("");
};


  const modificarCantidad = async (productId, cantidad) => {
    const productoEnCarrito = carrito.find(
      (producto) => producto._id === productId
    );
    const productoEnData = productosData.getProductos.find(
      (producto) => producto._id === productId
    );

    if (!productoEnCarrito || !productoEnData) return;

    const nuevaCantidad = productoEnCarrito.cantidad + cantidad;

    if (nuevaCantidad <= 0) {
      return eliminarProductoDelCarrito(productId);
    }

    if (productoEnData.stock === 0) {
     // alert('No hay suficiente stock disponible para este producto.');
      return;
    }

    const carritoActualizado = carrito.map((item) =>
      item._id === productId ? { ...item, cantidad: nuevaCantidad } : item
    );
    setCarrito(carritoActualizado);

    // const nuevoStock = productoEnData.stock - cantidad;
    // await actualizarStockProducto({
    //   variables: { id: productId, nuevoStock },
    // });
  };

  useEffect(() => {
    setCarritoLocal(carrito);  // Actualiza carritoLocal cuando carrito cambie
  }, [carrito]);
  
  const eliminarProductoDelCarrito = async (productId) => {
    const productoEnCarrito = carrito.find(
      (producto) => producto._id === productId
    );

    if (productoEnCarrito) {
      // const nuevoStock =
      //   data.getProductos.find((producto) => producto._id === productId).stock +
      //   productoEnCarrito.cantidad;
      // await actualizarStockProducto({
      //   variables: { id: productId, nuevoStock },
      // });
    }

    const carritoActualizado = carrito.filter(
      (producto) => producto._id !== productId
    );
    setCarrito(carritoActualizado);
  };

  const eliminarTodoElCarrito = async () => {
    for (let producto of carrito) {
      // const nuevoStock =
      //   data.getProductos.find((item) => item._id === producto._id).stock +
      //   producto.cantidad;
      // await actualizarStockProducto({
      //   variables: { id: producto._id, nuevoStock },
      // });
    }
    setCarrito([]);
    localStorage.setItem('carrito', JSON.stringify([]));
  };

  {/*const handleFiltroChange = (e) => {
    setFiltro(e.target.value);
  };*/}

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      buscarYAgregarProducto(filtro);
      setFiltro('');
    }
  };

  const recalcularTotal = () => {
    const nuevoTotal = carrito.reduce((acc, producto) => {
      const subtotal = producto.codigo === "1"
        ? (producto.precio * producto.cantidad) + 200
        : producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };
  
  const [productosFiltrados, setProductosFiltrados] = useState([]);

  const handleFiltroChange = (e) => {
    const filtro = e.target.value.toLowerCase();
    setFiltro(filtro);
    const productosFiltrados = productosData.getProductos.filter((producto) =>
      producto.nombre.toLowerCase().includes(filtro)
    );
    setProductosFiltrados(productosFiltrados);
    setIndiceSeleccionado(0);
  };
  
  // const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);


  const handleCompraClick = async () => {
  for (const producto of carrito) {
  //  await incrementarVendidos({
 // variables: {
  //  id: producto._id,
   // cantidad: parseInt(producto.cantidad, 10), // ✅ conversión segura
 // },
//});
  }

  localStorage.removeItem('carrito');
  setCarrito([]);
};


   // Generar mensaje de WhatsApp
   const generarMensajeWhatsapp = () => {
    let mensaje = `Hola ${nombreCliente}, gracias por tu compra.\n\nDetalles de compra:\n`;

  carritoLocal.forEach((producto) => {
  const precioCalculado = producto.codigo === "1"
    ? (producto.precio * 1000 + 200)
    : (producto.precio);

  mensaje += `${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${precioCalculado}\n`;
});

const totalPedido = carritoLocal.reduce((total, prod) => {
  const precioCalculado = prod.codigo === "1"
    ? prod.precio * 1000 + 200
    : prod.precio;
  return total + (precioCalculado * prod.cantidad);
}, 0);

mensaje += `\nTotal del pedido: ${totalPedido}\n`;
mensaje += `\nDirección de entrega: ${direccionCliente}\n`;
mensaje += `Nota: ${notaPedido}`;

return encodeURIComponent(mensaje);
  };

  // Generar PDF con datos del cliente y productos
  const generarPDF = () => {
    const doc = new jsPDF();
    
    // Añadir datos del cliente
  
    doc.text(`Cliente: ${nombreCliente}`, 10, 20);
    doc.text(`Dirección: ${direccionCliente}`, 10, 30);
    doc.text(`WhatsApp: ${whatsappCliente}`, 10, 40);
    
    // Añadir detalles del pedido
    doc.text("Detalles de la compra", 10, 50);
      doc.text("Detalles de la compra", 10, 50);
    carritoLocal.forEach((producto, index) => {
      doc.text(`${producto.nombre} - Cantidad: ${producto.cantidad} - Precio:0 ${producto.codigo === "1"
                    ? (producto.precio )*1000 + 200
                    : producto.precio}`, 10, 60 + (index * 10));
    });

  const total = carritoLocal.reduce((total, prod) => {
  const precioCalculado = prod.codigo === "1"
    ? prod.precio * 1000 + 200
    : prod.precio;
  return total + (precioCalculado * prod.cantidad);
}, 0);

doc.text(`Total del pedido: ${total.toFixed(0)}`, 10, 70 + (carritoLocal.length * 10));

doc.save('pedido.pdf'); 
  };

 const pedidoSubmit = async (e) => {
  e.preventDefault();

  // 🚫 Si ya se está enviando, no permitir otro envío
  if (loadingPedido) return;

  try {
    setLoadingPedido(true);

    const carritoString = JSON.stringify(carritoLocal);

    await nuevoPedido({
      variables: {
        estado,
        fecha,
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

    await refetchUltimoPedido();

    handleCompraClick();

    // Limpiar campos
    setNombreCliente("");
    setFecha(formatFechaGMT5());
    setDireccionCliente("");
    setWhatsappCliente("");
    setNotaPedido("");
    setDineroCliente("");

  } catch (error) {
    console.error("Error creando pedido:", error);
  } finally {
    setLoadingPedido(false); // 🔓 vuelve a habilitar
  }
};


   useEffect(() => {
  const entregado = parseFloat(dineroCliente);
  if (!isNaN(entregado)) {
    setCambio(entregado - total);
  } else {
    setCambio(0);
  }
}, [dineroCliente, total]);

useEffect(() => {
  const handleKeyDown = (event) => {
    if (!productosFiltrados.length) return;
    const columnasPorFila = 6;
    let nuevoIndice = indiceSeleccionado;

    switch (event.key) {
      case 'ArrowRight':
        nuevoIndice = (indiceSeleccionado + 1) % productosFiltrados.length;
        break;
      case 'ArrowLeft':
        nuevoIndice = (indiceSeleccionado - 1 + productosFiltrados.length) % productosFiltrados.length;
        break;
      case 'ArrowDown':
        if (productosFiltrados.length >= columnasPorFila) {
          nuevoIndice = indiceSeleccionado + columnasPorFila;
          if (nuevoIndice >= productosFiltrados.length) {
            nuevoIndice = productosFiltrados.length - 1;
          }
        }
        break;
      case 'ArrowUp':
        if (productosFiltrados.length >= columnasPorFila) {
          nuevoIndice = indiceSeleccionado - columnasPorFila;
          if (nuevoIndice < 0) {
            nuevoIndice = 0;
          }
        }
        break;
      case 'Enter':
        agregarAlCarrito(productosFiltrados[indiceSeleccionado]);
        break;
      default:
        return;
    }

    setIndiceSeleccionado(nuevoIndice);
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [productosFiltrados, indiceSeleccionado, agregarAlCarrito]);

useEffect(() => {
  const handleCantidadConTeclado = (event) => {
    if (carrito.length === 0) return;

    if (event.key === '+' || event.key === '-') {
      event.preventDefault(); // 🔴 Evita que escriba en el input

      const ultimoProducto = carrito[carrito.length - 1];

      if (event.key === '+') {
        modificarCantidad(ultimoProducto._id, 1);
      } else if (event.key === '-') {
        modificarCantidad(ultimoProducto._id, -1);
      }
    }



    
  };

  

  window.addEventListener('keydown', handleCantidadConTeclado);

  return () => {
    window.removeEventListener('keydown', handleCantidadConTeclado);
  };
}, [carrito]);


useEffect(() => {
  const handleKeyFinalizarVenta = (event) => {
    // Si se presiona * desde teclado alfanumérico o teclado numérico
    if (event.key === '*' || event.code === 'NumpadMultiply') {
      event.preventDefault();

      // Buscar el formulario y enviarlo
      const formulario = document.querySelector('form');
      if (formulario) {
        formulario.requestSubmit(); // Dispara el submit del formulario
      }
    }
  };

  window.addEventListener('keydown', handleKeyFinalizarVenta);

  return () => {
    window.removeEventListener('keydown', handleKeyFinalizarVenta);
  };
}, []);


   if (productosLoading || pesoLoading || ultimopedidoLoading) return <p><FruitLoader></FruitLoader></p>;
  if (productosError) return <p>Error al cargar productos</p>;
  if (pesoError) return <p>Error al leer la báscula</p>;
 if (ultimopedidoError) return <p>Error </p>;
  
  const ultimoPedido = ultimopedidoData.obtenerUltimoPedido;
  return (
    <div className="">
   <a className="btn-prod-sincodigo btn" href="caja-auxiliar" target="_blank">Abrir Caja 2</a>
    <a className="crear-producto btn" href="/crear-product">
      Crear producto
    </a>
    <a className="editar-producto btn" href="/buscar-y-agregar">
      Editar producto
    </a>
    <a className="numero-compra btn" href="/10pedidos"  target="_blank">
    <h4># {ultimoPedido.numeroPedido}</h4>
     
    </a>
    <button className="btn gestion-agotados" onClick={() => setModalActivo("agotados")}>
 Gestion Agotados
</button>
   <button className="btn gestion-cambios" onClick={() => setModalActivo("cambios")}>
 Cambios
</button>
    <div className="container ">
          {carrito.length === 0 && (
  <div className="img-fondo">
    
  </div>
)}
      <div className="row">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyDown={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>

        <div>
  <button className='btn btn-salida'><h1>Caja 1</h1></button>   <button className='btn btn-salida'><h1> { pesoData?.pesoBascula*1000 || 0.00} gramos</h1></button>   
     
</div>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
               {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-2">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(209, 223, 219, 0.7)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
            <h4 style={{ margin: 0 }}>
              ${producto.codigo === "1"
                ? producto.precio * 1000 + 200
                : producto.precio}
            </h4>

            {producto.codigo === "1" && (
              <p style={{ margin: 0 }}>
                <strong>{pesoData?.pesoBascula || 0.0} kg</strong>
              </p>
            )}

            <h3 style={{ margin: 0 }}>
              {producto.codigo === "1"
                ? pesoData?.pesoBascula > 0
                  ? ((pesoData.pesoBascula * 1000) * producto.precio + 200).toFixed(0)
                  : "0"
                : ""}
            </h3>
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          <ul>
            {carrito.slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >
                <div className="producto-nombre">
                  <img src={producto.imagen} width="40px" alt="" /> {producto.nombre}
                </div>
                <div className="producto-precio">
                  ${producto.codigo === "1"
                    ? (producto.precio )*1000 + 200
                    : producto.precio}
                </div>
                <div className="producto-cantidad">
                  <button className="btn btn-salida" onClick={() => modificarCantidad(producto._id, -1)}>
                    -
                  </button>
                  {producto.cantidad}
                  <button className="btn btn-salida" onClick={() => modificarCantidad(producto._id, 1)}>
                    +
                  </button>
                </div>
                <div className="producto-subtotal">
                  Subtotal: $
                  {producto.codigo === "1"
                    ? ((producto.precio) * producto.cantidad) + 200
                    : producto.precio * producto.cantidad}
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-2">
          {carrito.length > 0 && (
            <>
              
              
              <form onSubmit={pedidoSubmit}>
          {/*<input type="hidden" name="estado" value="esperando" />
          <input type="text" name="fecha" value={fecha} /> {/* Fecha con GMT-5 
          <h3>Cliente</h3>
          <input placeholder="nombre completo" value={nombreCliente} onChange={evt => setNombreCliente(evt.target.value)} />
          <h3>Direccion</h3>
          <input placeholder="ejemplo: calle 123 #01-01" value={direccionCliente} onChange={evt => setDireccionCliente(evt.target.value)} />
          <h3>Whatsapp (se usara para notificaciones del pedido)</h3>
          <input placeholder="ejemplo: 3010000000" value={whatsappCliente} onChange={evt => setWhatsappCliente(evt.target.value)} />
          <h3>Notas de pedido</h3>
          <input placeholder="ejemplo: informacion adicional del pedido" value={notaPedido} onChange={evt => setNotaPedido(evt.target.value)} />
          <input type="hidden" value={JSON.stringify(carritoLocal, null, 2)} />
          <br />
          <br />*/}
         <h1><button 
  className="btn btn-salida"
  disabled={loadingPedido}
>
  <h3>
    {loadingPedido ? "Procesando..." : "Finalizar Venta"}
  </h3>
</button>
</h1> 
        </form>
        
        <a className="btn btn-salida" href="/lector-qr">
                <h3>Registrar venta al cliente</h3>
              </a>
<input
  type="number"
  id="dineroCliente"
  className="form-control"
  placeholder="Ej. 50000"
  value={dineroCliente}
  onChange={(e) => setDineroCliente(e.target.value)}
  onFocus={() => setMantenerFocoBusqueda(false)}
  onBlur={() => setMantenerFocoBusqueda(true)} // ⚡ vuelve a activar el foco automático
/>
{dineroCliente && (
  <div className="mt-2">
    <h1>
      Cambio: <span style={{ color: cambio < 0 ? 'red' : 'black' }}>
        ${cambio.toFixed(0)}
      </span>
    </h1>
  </div>
)}

        <h1>Total: <h1>
  <span style={{ backgroundColor: 'white', color: 'black', padding: '4px 8px', borderRadius: '5px' }}>
    ${total.toFixed(0)}
  </span>
</h1></h1>
            </>
          )}
          
        </div>

      {/*<div className='col-1'>  <ProductosAgotados></ProductosAgotados></div>*/}
        {modalActivo === "agotados" && (
    <div
   
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title"></h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

<ProductosAgotados></ProductosAgotados>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

     {modalActivo === "cambios" && (
    <div
   
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title"></h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

<Cambios></Cambios>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
      </div>
    </div>
  </div>
  );
  
}

export default GetProductos;
